module.exports = __webpack_public_path__ + "static/media/company-profile-preview-cover.efd02f13.png";